import React, { useState } from "react";
import { Form, Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { createPhoto } from "../../http/photoAPI";

const AddPhotoForm = ({ onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);

  const handleSubmit = async () => {
    try {
      setLoading(true);

      if (fileList.length === 0) {
        message.error("Please upload a photo!");
        setLoading(false);
        return;
      }
      const formData = new FormData();
      formData.append("img_main", fileList[0].originFileObj);
      const response = await createPhoto(formData);
      console.log(response)
      message.success("Photo uploaded successfully!");

      if (onSuccess) onSuccess(response);
      if (onClose) onClose();
    } catch (error) {
      console.error("Error uploading photo:", error);
      message.error("Failed to upload photo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleSubmit}>
      <Form.Item
        label="Upload Photo"
        name="img_main"
        rules={[{ required: true, message: "Please upload a photo" }]}
      >
        <Upload
          beforeUpload={() => false} // prevent auto upload
          fileList={fileList}
          onChange={({ fileList }) => setFileList(fileList)}
          accept="image/*"
        >
          <Button icon={<UploadOutlined />}>Click to Upload</Button>
        </Upload>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Upload Photo
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AddPhotoForm;
